// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-upload-dragger {\n  background-color: #fff;\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  box-sizing: border-box;\n  width: 490px;\n  height: 180px;\n  text-align: center;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
